import React from 'react';
import { SspProviderContext } from './interfaces';

const CONTEXT: React.Context<SspProviderContext> = React.createContext(
	{} as SspProviderContext
);

export default CONTEXT;
